//#region libraries
import React, { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { QRCode } from 'react-qrcode-logo';

// bootstrap
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Modal from 'react-bootstrap/Modal';

// custom components
import { Title, NewScreen, Accordion } from "_atoms";
import { TableValue, TableHeader } from "_molecules";
// import { TimelineAreaTable, AirportLocationsTable, FlightsTable } from "_organisms";
import TimelineAreaTable from "./timeline-area-table";
import AirportLocationsTable from "./airportlocations-table";
import AddTimelineAreaForm from "./add-timelinearea-form";
import DeleteTimelinearea from "./delete-timelinearea";
import HandleAirportLocationForm from "./handle-airportlocation-form";
import DeleteAirportLocation from "./delete-airportlocation";
import ActionsModal from "_components/molecules/Modals/actions-modal";
// redux
import { useSelector, useDispatch } from "react-redux";
import { resetBookings, setFlightsTypeFilter } from "_redux/slices/timeline/timeline-data";
import { reset as resetSelectedTask, resetSelectedTasksList } from "_redux/slices/timeline/selected-task";
import {
  selectAllTimelineAreas,
  getTimelineAreas,
  setSelectedTimeline,
  selectArrivalsTimelineAreas,
  selectDeparturesTimelineAreas,
  selectDeparturesAndArrivalsTimelineAreas,
  setBookingType,
  selectBookingType,
  selectDeleteTimelineAreaStatus,
  getAirportLocation,
  resetAddTimelineAreaFlags,
  resetAirportLocationsFlags,
  setSelectedAirportLocation,
  selectAddAirportLocationsStatus,
  selectEditAirportLocationsStatus,
  selectDeleteAirportLocationsStatus,
  selectSelectedTimeline,
  selectSelectedAirportLocation,
  editAirportLocation,
  selectAllAirportLocations
} from "_redux/slices/timeline/timeline-areas";
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";
import { setTimeLineDate } from "_redux/slices/timeline/timeline-control";
import {
  setEmployeeSearch,
} from "_redux/slices/timeline/employees";

//icons
import { RiDeleteBin5Line } from "react-icons/ri";
import { MdEdit } from "react-icons/md";
import { LuBookmarkPlus } from "react-icons/lu";
import { CiBookmarkMinus } from "react-icons/ci";
import { BsDownload } from 'react-icons/bs';
import { ImQrcode } from "react-icons/im";
import brandLogo from "_assets/images/prm-logo/blue-icon.png";
import { FaChevronRight } from "react-icons/fa6";

//styles
import { Spacing } from "_styles";
import StaffEquipments from "../employee-components/staff-equipments";
import { getStaffEquipments } from "_redux/slices/timeline/staff-equipments";
const iconStyles = {
  marginInlineEnd: "20px",
  fontSize: "26px",
  borderRadius: "4px",
  padding: "2px 6px",
  transition: "all 0.3s ease", // Add a smooth transition
};

// utils
import { handleQrCodeDownload, handleQrCodeDownloadAllPdf, handlePaxQrCodeDownload, handlePaxQrCodeDownloadAllPdf } from "_scenes/portal/utils/airport-location-qr-code";
import RejectReasons from "_scenes/portal/timeline/timeline-components/reject-reasons";
import { getRejectReasons } from "_redux/slices/timeline/reject-reasons";
//#endregion

const Timeline = () => {

  // nav
  const history = useHistory();

  //#region redux 
  const dispatch = useDispatch();

  const allTimelineAreas = useSelector(selectAllTimelineAreas);                                       // select all timelineAreas
  const allAirportLocations = useSelector(selectAllAirportLocations);                                       // select all airport locations
  const arrivalsTimelineAreas = useSelector(selectArrivalsTimelineAreas);                             // select arrivales timelineAreas
  const departuresTimelineAreas = useSelector(selectDeparturesTimelineAreas);                         // select departures timelineAreas
  const departuresAndArrivalsTimelineAreas = useSelector(selectDeparturesAndArrivalsTimelineAreas);   // select departures and arrivals(both) timelineAreas

  const bookingType = useSelector(selectBookingType);                                                 // select bookingType (departures,arrivals)
  const deleteTimelineAreaStatus = useSelector(selectDeleteTimelineAreaStatus);
  const addAirportLocationsStatus = useSelector(selectAddAirportLocationsStatus)                      // add Airport Location Status
  const editAirportLocationsStatus = useSelector(selectEditAirportLocationsStatus)                    // edit Airport Location Status
  const deleteAirportLocationsStatus = useSelector(selectDeleteAirportLocationsStatus);               // delete Airport Location status                                               
  const selectedTimeLine = useSelector(selectSelectedTimeline)
  const selectedAirportLocation = useSelector(selectSelectedAirportLocation)                    // selected airport location to edit or delete

  const dbUser = useSelector(selectFirebaseInfo);
  //#endregion

  //#region local states
  const [timelineAreas, setTimelineAreas] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);                              // show add employee modal
  const [deleteModal, setDeleteModal] = useState(false);                                // show delete modal
  const [showALModal, setShowALModal] = useState(false);                                // show handle Airport Location modal (add, edit)
  const [deleteALModal, setDeleteALModal] = useState(false);                            // show delete Airport Location modal 
  const [locationSearchValue, setLocationSearchValue] = useState("");                // hold the value of the search field for location 
  const [airportLocations, setAirportLocations] = useState([]);                         // array of the displayed locations
  const [showQrCodeModal, setShowQrCodeModal] = useState(false);                        // show QR Code modal
  const [selectedQrCodeLocation, setSelectedQrCodeLocation] = useState(null);           // selected location for QR Code
  const [selectedLocation, setSelectedLocation] = useState([]);                       // selected location for single download
  const [pdfDownloadProgress, setPdfDownloadProgress] = useState(0);                    // CCA PDF download progress (0-100)
  const [isDownloadingPdf, setIsDownloadingPdf] = useState(false);                      // CCA PDF download in progress
  const [paxPdfDownloadProgress, setPaxPdfDownloadProgress] = useState(0);              // PAX PDF download progress (0-100)
  const [isDownloadingPaxPdf, setIsDownloadingPaxPdf] = useState(false);                // PAX PDF download in progress

  //#endregion

  //#region use effects
  useEffect(() => {
    // on render get list of timeline areas from back end and reset time line data flags
    dispatch(getTimelineAreas(dbUser.details.authority));

    // on render get list of locations from back end 
    dispatch(getAirportLocation(dbUser.details.authority));


    //  reset timelineareas and airportLocations flags
    dispatch(resetAddTimelineAreaFlags());
    dispatch(resetAirportLocationsFlags());

    // reset timeline data object
    // dispatch(resetTimelineData());
    dispatch(resetBookings());

    // reset selected task data
    dispatch(resetSelectedTask());
    dispatch(resetSelectedTasksList());

    // reset Flights Type Filter to all
    dispatch(setFlightsTypeFilter("all"));
    dispatch(setSelectedTimeline(null));
    dispatch(setBookingType(["all"]));

    // reset timelineDate to current date 
    dispatch(setTimeLineDate(new Date()))
    if (dbUser.details.type === "AIRPORT") {
      dispatch(getStaffEquipments(dbUser.details.authority))
      const params = {
        source: "ALL",
        airport: dbUser.details.authority
      }
      dispatch(getRejectReasons(params));
    }

  }, []);

  useEffect(() => {
    if (Array.isFullArray(allAirportLocations)) {
      setAirportLocations([...allAirportLocations]);
    } else setAirportLocations([]);
  }, [allAirportLocations]);

  // set the time line areas by the booking type filter(all ,arrivals, departures)
  useEffect(() => {
    if (bookingType?.includes("departures")) {
      setTimelineAreas(departuresTimelineAreas);
    }
    if (bookingType?.includes("arrivals")) {
      setTimelineAreas(arrivalsTimelineAreas);
    }
    if (bookingType?.includes("all")) {
      // all in here means show the time zones that is both for departures and arrivals
      // add the all airport view to the timeline areas
      setTimelineAreas(Array.isFullArray(departuresAndArrivalsTimelineAreas)
        ? [
          {
            "_id": "all-airport-view",
            "iata": dbUser.details.authority,
            "title": "All Airport View",
            "location": [],
            "international": true,
            "domestic": true,
            "arrivals": true,
            "departures": true,
            "holdingArea": false,
            "jobsType": ["all"]
          },
          ...departuresAndArrivalsTimelineAreas
        ]
        : []);
    }
  }, [bookingType, allTimelineAreas, arrivalsTimelineAreas, departuresTimelineAreas]);

  useEffect(() => {
    if (deleteTimelineAreaStatus === "succeeded") {
      dispatch(getTimelineAreas(dbUser.details.authority));
      setDeleteModal(false)
      dispatch(setSelectedTimeline(null));
    }
  }, [deleteTimelineAreaStatus]);

  useEffect(() => {
    if (addAirportLocationsStatus === "succeeded" || editAirportLocationsStatus === "succeeded" || deleteAirportLocationsStatus === "succeeded") {
      dispatch(getAirportLocation(dbUser.details.authority));
      dispatch(getTimelineAreas(dbUser.details.authority));
      closeALModal();
      closeALDeleteModal();
      dispatch(resetAirportLocationsFlags());
      setLocationSearchValue("");
    }
    if (addAirportLocationsStatus === "failed" || editAirportLocationsStatus === "failed" || deleteAirportLocationsStatus === "failed") {
      closeALModal()
      closeALDeleteModal()
      dispatch(resetAirportLocationsFlags());

    }
  }, [addAirportLocationsStatus, editAirportLocationsStatus, deleteAirportLocationsStatus]);

  //#endregion

  //#region table variables

  // table columns
  let timelineAreasColumns = useMemo(() => [
    {
      Header: <TableHeader title={"Area"} />,
      accessor: "title",
      // render custom object
      Cell: ({ cell: { value } }) => (
        <div>
          <TableValue title={value} comment={false} />
        </div>
      ),
    },
    {
      Header: <TableHeader title={""} />,
      accessor: "actions",
      // render custom object
      Cell: ({ cell: props }) => (
        bookingType?.includes("all") && props?.row?.original?._id === "all-airport-view"
          ? <div style={{ padding: 12, paddingRight: 30, justifyContent: "flex-end", display: "flex" }}>
            <Button variant="primary">
              <FaChevronRight onClick={handleViewAll} color={'white'} />
            </Button>

          </div>
          : <div style={{ padding: 12, justifyContent: "flex-end", display: "flex" }}>
            <Button variant="outline-danger" style={iconStyles}>
              <RiDeleteBin5Line
                onClick={(event) => handleDelete(props?.row?.original?._id, event)}
              />
            </Button>
            <Button variant="outline-primary" style={iconStyles} >
              <MdEdit
                onClick={(event) => {
                  handleEdit(props?.row?.original?._id, event);
                }}
              />
            </Button>

          </div>


      ),
    },
  ]);

  // table columns
  let airportLocationsColumns = useMemo(() => [
    {
      Header: <TableHeader title={"Title"} />,
      accessor: "title",
      // render custom object
      Cell: ({ cell: { value } }) => (
        <div>
          <TableValue title={value} comment={false} />
        </div>
      ),
    },
    {
      Header: <TableHeader title={"Area"} />,
      accessor: "timelineId",
      // render custom object
      Cell: ({ cell: { value } }) => (
        <div>
          <TableValue title={getTimeLineAreaName(value)} comment={false} />
        </div>
      ),
    },
    {
      Header: <TableHeader title={"Type"} />,
      accessor: "_id",
      // render custom object
      Cell: ({ cell: { value } }) => (
        <div>
          <TableValue title={getLocationType(value)} comment={false} />
        </div>
      ),
    },
    {
      Header: <TableHeader title={""} />,
      accessor: "actions",
      // render custom object
      Cell: ({ cell: props }) => {
        const rowId = props?.row?.original?._id;
        return (
          <div style={{ padding: 12, justifyContent: "flex-end", display: "flex" }}>
            <div className="qrcode-scan-button"
              onClick={() => handleQrCodeShow(props?.row)}
              style={{
                position: "relative", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer"
              }}
            >
              <Button variant="outline-primary" style={iconStyles} >
                <ImQrcode
                />
              </Button>

            </div>
            {
              (
                <Button variant="outline-primary" style={iconStyles} onClick={(event) => handleAddBookMark(props?.row?.original?._id, event)}>
                  {props?.row.original.isBookMark ? <CiBookmarkMinus /> : <LuBookmarkPlus />}
                </Button>
              )
            }

            <Button variant="outline-danger" style={iconStyles}>
              <RiDeleteBin5Line
                onClick={(event) => handleALDelete(props?.row?.original?._id, event)}
              />
            </Button>
            <Button variant="outline-primary" style={iconStyles} >
              <MdEdit
                onClick={(event) => {
                  handleALEdit(props?.row?.original?._id, event);
                }}
              />
            </Button>


          </div>
        )
      },
    },
  ]);
  //#endregion

  // #region functions


  // navigate to the timeline clicked from the table
  const handleAreaClick = (rowIndex) => {
    // set selected timeline area
    let area = timelineAreas[rowIndex];

    // if the area is not the all airport view, then set the booking type and selected timeline
    if (area?._id !== "all-airport-view") {
      if (Array.isFullArray(area?.jobsType)) {
        dispatch(setBookingType(area?.jobsType));
      }
      dispatch(setSelectedTimeline(area));
    }
    dispatch(setEmployeeSearch(""));

    // navigate to the timeline
    history.push(`/timeline-view-v2`);
  };

  const handleViewAll = () => {
    dispatch(setBookingType(["all"]));

    history.push(`/timeline-view-v2`);
  };

  // edit airport area
  const handleEdit = (areaId, event) => {
    // Stop the event from clicking on the parent dev
    event.stopPropagation();
    let area = timelineAreas?.find((areaObj) => areaObj?._id == areaId);
    if (area) {
      handleOpenModal();
      dispatch(setSelectedTimeline(area));
    }
  }
  // edit airport location
  const handleALEdit = (locationId) => {
    let tempLocation = allAirportLocations?.find((locationObj) => locationObj?._id == locationId);
    if (tempLocation) {
      openALModal();
      dispatch(setSelectedAirportLocation(tempLocation));

    }
  }

  //mark location as bookmark (special location)
  const handleAddBookMark = (locationId, event) => {
    // Stop the event from clicking on the parent dev
    event.stopPropagation();

    const location = allAirportLocations?.find((locationObj) => locationObj._id === locationId);
    const body = { ...location, isBookMark: !location.isBookMark }
    const data = { body, id: locationId }

    dispatch(editAirportLocation(data))
  }

  const handleDelete = (areaId, event) => {
    // Stop the event from clicking on the parent dev
    event.stopPropagation();
    // let area = timelineAreas[rowIndex];
    let area = timelineAreas?.find((areaObj) => areaObj?._id == areaId);
    if (area) {
      setDeleteModal(true)
      dispatch(setSelectedTimeline(area));
    }
  }

  // delete airport location
  const handleALDelete = (locationId) => {
    let tempLocation = allAirportLocations?.find((locationObj) => locationObj?._id == locationId);
    if (tempLocation) {
      setDeleteALModal(true);
      dispatch(setSelectedAirportLocation(tempLocation));

    }
  }

  // modal close handler
  const closeAddModal = () => {
    setShowAddModal(false); // close modal
    dispatch(setSelectedTimeline(null));
  };

  // modal close airport Location handler
  const closeALModal = () => {
    setShowALModal(false);
    dispatch(setSelectedAirportLocation(null));
  };

  //open airport location modal 
  const openALModal = () => {
    setShowALModal(true);
  };

  // modal open handler
  const handleOpenModal = () => {
    setShowAddModal(true); // close modal
  };

  const closeDeleteModal = () => {
    setDeleteModal(false);
    dispatch(setSelectedTimeline(null));
  }

  // close delete airport location modal
  const closeALDeleteModal = () => {
    setDeleteALModal(false);
    dispatch(setSelectedAirportLocation(null));
  }

  const getTimeLineAreaName = (areaId) => {
    if (!Array.isFullArray(allTimelineAreas)) return "N/A"
    if (typeof areaId === "string") {
      let tempArea = allTimelineAreas.find(area => area._id == areaId)
      return tempArea?.title ?? "N/A"
    } else {
      if (Array.isFullArray(areaId)) {
        let tempAreas = allTimelineAreas.filter(area => areaId?.includes(area._id));

        if (Array.isFullArray(tempAreas)) return `${tempAreas?.[0]?.title} ${tempAreas?.length > 1 ? `...+${tempAreas?.length - 1}` : ""}`
        else return "N/A"
      } else return "N/A"
    }
  };
  const getLocationType = (locationId) => {
    if (!Array.isFullArray(allAirportLocations)) return ""
    let tempLocation = allAirportLocations.find(location => location._id == locationId)
    // return tempArea?.title
    if (!tempLocation) return ""
    if (tempLocation?.pickUp) return "Pick Up";
    else if (tempLocation?.dropOff) return "Drop Off";
    else return "Pick Up / Drop Off";
  };


  const handleSearchLocation = (searchValue) => {
    setLocationSearchValue(searchValue);
    // filter the airport locations based on the search value
    let cleanSearchTerm = searchValue.toLowerCase().replace(/\s/g, '');
    let tempLocations = allAirportLocations.filter((location) => {
      let cleanLocationName = location.title.toLowerCase().replace(/\s/g, '');
      return cleanLocationName.includes(cleanSearchTerm);
    });

    setAirportLocations(Array.isFullArray(tempLocations) ? [...tempLocations] : []);
  }


  const handleExportCSV = () => {
    if (!Array.isFullArray(airportLocations)) return;

    const headers = ["Title", "Area", "Type"];
    const csvRows = airportLocations.map((location) => {
      const title = location.title || "";
      const area = getTimeLineAreaName(location.timelineId);
      const type = getLocationType(location._id);
      return [title, area, type]
        .map((field) => `"${String(field).replace(/"/g, '""')}"`)
        .join(",");
    });

    const csvContent = [headers.join(","), ...csvRows].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "airport_locations.csv";
    link.click();
    URL.revokeObjectURL(url);
  };

  // handle QR Code show
  const handleQrCodeShow = (data) => {
    console.log("QR Code Data", data);
    let qrData = {
      id: data?.original?._id,
      title: data?.original?.title,
      iata: data?.original?.iata,
    }
    setShowQrCodeModal(true);
    setSelectedQrCodeLocation(qrData);
    setSelectedLocation([data?.original]);
  }
  //#endregion


  return (
    <NewScreen>

      {/* title */}
      <Row>
        <Col>
          <Title subtitle={"Bookings Timeline"} description={"Allocate bookings to your airport porters and view timeline areas"} />
        </Col>
      </Row>

      <TimelineAreaTable
        title={"Airport Area List"}
        description={"View the areas in your airport"}
        typeSwitch={bookingType}
        showTypeSwitch={true}
        setTypeSwitch={(type) => { dispatch(setBookingType([type])) }}
        data={Array.isFullArray(timelineAreas) ? timelineAreas : []}
        columns={timelineAreasColumns}
        clickable={true}
        handleClick={handleAreaClick}
        handleOpenModal={handleOpenModal}
        handleViewAll={handleViewAll}
      />

      <div style={{ marginTop: Spacing.SCALE_10 }}>
        <Accordion header={"Airport Locations"} active={true} onStateChange={() => { /*console.log('changed state'*/ }}>
          <AirportLocationsTable
            title={"Airport Locations List"}
            description={"View the different drop off / pick up locations in your airport, including gates, check in desks and holding areas"}
            data={Array.isFullArray(airportLocations) ? airportLocations : []}
            columns={airportLocationsColumns}
            locationSearchValue={locationSearchValue}
            handleOpenModal={openALModal}
            handleEdit={handleALEdit}
            handleDelete={handleALDelete}
            handleSearchLocation={handleSearchLocation}
            handleExportCSV={handleExportCSV}
          />
        </Accordion>
      </div>

      <div style={{ marginTop: Spacing.SCALE_10, marginBottom: Spacing.SCALE_10 }}>
        <Accordion header={"Staff Equipments"} active={false} onStateChange={() => { /*console.log('changed state'*/ }} onClick={() => console.log("clicked!!")}>
          <StaffEquipments />
        </Accordion>
      </div>

      <div style={{ marginTop: Spacing.SCALE_10, marginBottom: Spacing.SCALE_10 }}>
        <Accordion header={"Reject Reasons"} active={false} onStateChange={() => { /*console.log('changed state'*/ }} onClick={() => console.log("clicked!!")}>
          <RejectReasons />
        </Accordion>
      </div>


      {/* Add timeline zones Form */}
      <ActionsModal show={showAddModal}
        handleClose={closeAddModal}
        title={Object.isObjectEmpty(selectedTimeLine) ? "Create Airport Area" : "Edit Airport Area"}
        subtitle={Object.isObjectEmpty(selectedTimeLine) ? `To create an area in your airport fill in the below form and add any airport locations that are within the airport area and click confirm` : `To edit an airport area update the information below and click confirm`}
        minWidth="445px"
        maxWidth="445px"
        isTimeline={false}
      >
        <AddTimelineAreaForm closeModal={closeAddModal} />
      </ActionsModal>

      {/* {deleteModal&& renderDeleteModal()} */}
      <ActionsModal show={deleteModal} handleClose={closeDeleteModal} title="Delete Timeline" minWidth="445px" maxWidth="445px" isTimeline={false}>
        <DeleteTimelinearea closeModal={closeDeleteModal} />
      </ActionsModal>

      {/* Add and edit location Form */}
      <ActionsModal
        show={showALModal}
        //show={true}
        handleClose={closeALModal}
        title={Object.isObjectEmpty(selectedAirportLocation) ? "Create Airport Location" : "Edit Airport Location"}
        subtitle={Object.isObjectEmpty(selectedAirportLocation) ? `To create a Airport Location enter the information below and click confirm` : `To edit a Airport Location update the information below and click confirm`}
        minWidth="700px"
        maxWidth="700px"
        isTimeline={false}>
        <HandleAirportLocationForm closeModal={closeALModal} />
      </ActionsModal>
      {/* {delete location} */}
      <ActionsModal show={deleteALModal} handleClose={closeALDeleteModal} title="Delete Airport Location" minWidth="445px" maxWidth="445px" isTimeline={false}>
        <DeleteAirportLocation closeModal={closeALDeleteModal} />
      </ActionsModal>

      {/* QR Code Modal — CCA (staff) + PAX (passenger) side by side */}
      <Modal id="qrCodeModal" show={showQrCodeModal} onHide={() => { setShowQrCodeModal(false); setSelectedQrCodeLocation(null); setSelectedLocation([]); }} animation={false} size="lg">
        <Modal.Header closeButton style={{ borderBottom: '1px solid #e5e7eb', paddingBottom: 12 }}>
          <Modal.Title style={{ fontSize: 16, fontWeight: 700, color: '#111827' }}>
            QR Codes - {selectedQrCodeLocation?.title || 'Location'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '24px 28px', background: '#fafafa' }}>
          <div style={{ display: "flex", gap: 24, justifyContent: "center", flexWrap: "wrap" }}>

            {/* ── CCA column ── */}
            <div style={{ flex: "1 1 220px", maxWidth: 260, display: "flex", flexDirection: "column", alignItems: "center", gap: 12, background: '#eff6ff', borderRadius: 12, padding: '20px 16px', boxShadow: '0 1px 4px rgba(22,77,217,0.08)', border: '1px solid #dbeafe' }}>
              {/* Label */}
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                <span style={{ background: "#164dd9", color: "#fff", borderRadius: 6, padding: "3px 14px", fontSize: 13, fontWeight: 700, letterSpacing: 1 }}>CCA</span>
                <span style={{ fontSize: 11, color: '#3b82f6', fontWeight: 500, letterSpacing: 0.3 }}>Staff App</span>
              </div>
              {/* QR */}
              <QRCode
                value={JSON.stringify(selectedQrCodeLocation)}
                size={200}
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                fgColor="#000000"
                bgColor="#fff"
                title={'Scan for location details'}
                logoImage={brandLogo}
                logoWidth={36}
                logoHeight={36}
                logoOpacity={1}
                logoPaddingStyle="square"
                qrStyle="square"
                eyeColor="#000000"
                quietZone={6}
                removeQrCodeBehindLogo={false}
                logoPadding={1}
              />
              <p style={{ fontSize: 12, color: "#9ca3af", margin: 0, textAlign: 'center' }}>Scanned by CCA in the staff app</p>
              {/* Download single */}
              <button
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, width: '100%', height: 38, borderRadius: 7, border: '1.5px solid #164dd9', background: '#eff6ff', color: '#164dd9', fontWeight: 600, fontSize: 13, cursor: 'pointer', transition: 'all 0.15s' }}
                title="Download CCA QR Code"
                onClick={() => handleQrCodeDownload(selectedLocation)}
                onMouseEnter={e => { e.currentTarget.style.background = '#164dd9'; e.currentTarget.style.color = '#fff'; }}
                onMouseLeave={e => { e.currentTarget.style.background = '#eff6ff'; e.currentTarget.style.color = '#164dd9'; }}
              >
                <BsDownload size={14} /> Download CCA
              </button>
              {/* Download All CCA PDF */}
              <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 6 }}>
                <button
                  title="Download All CCA QR Codes as PDF"
                  disabled={isDownloadingPdf}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 6,
                    width: '100%',
                    height: 38,
                    borderRadius: 7,
                    border: '1.5px solid #bfdbfe',
                    background: isDownloadingPdf ? '#dbeafe' : '#eff6ff',
                    color: '#1d4ed8',
                    fontWeight: 600,
                    fontSize: 13,
                    cursor: isDownloadingPdf ? 'not-allowed' : 'pointer',
                    whiteSpace: 'nowrap',
                    transition: 'all 0.15s'
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background = '#164dd9'; e.currentTarget.style.color = '#fff'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = '#eff6ff'; e.currentTarget.style.color = '#164dd9'; }}
                  onClick={async () => {
                    setIsDownloadingPdf(true);
                    setPdfDownloadProgress(0);
                    try {
                      await handleQrCodeDownloadAllPdf(allAirportLocations, (progress) => {
                        setPdfDownloadProgress(progress);
                      });
                    } catch (error) {
                      console.error("Error downloading PDF:", error);
                      alert("Error generating PDF. Please try again.");
                    } finally {
                      setIsDownloadingPdf(false);
                      setPdfDownloadProgress(0);
                    }
                  }}
                >
                  <BsDownload size={14} />
                  {isDownloadingPdf ? `${pdfDownloadProgress}%…` : "Download All (PDF)"}
                </button>
                {isDownloadingPdf && (
                  <div style={{ width: '100%', height: 4, backgroundColor: '#e5e7eb', borderRadius: 4, overflow: 'hidden' }}>
                    <div style={{ width: `${pdfDownloadProgress}%`, height: '100%', backgroundColor: '#164dd9', transition: 'width 0.3s ease' }} />
                  </div>
                )}
              </div>
            </div>

            {/* Divider */}
            <div style={{ width: 1, background: '#e5e7eb', alignSelf: 'stretch', flexShrink: 0, margin: '8px 0' }} />

            {/* ── PAX column ── */}
            <div style={{ flex: "1 1 220px", maxWidth: 260, display: "flex", flexDirection: "column", alignItems: "center", gap: 12, background: '#f5f3ff', borderRadius: 12, padding: '20px 16px', boxShadow: '0 1px 4px rgba(111,66,193,0.08)', border: '1px solid #e9d5ff' }}>
              {/* Label */}
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                <span style={{ background: "#6f42c1", color: "#fff", borderRadius: 6, padding: "3px 14px", fontSize: 13, fontWeight: 700, letterSpacing: 1 }}>PAX</span>
                <span style={{ fontSize: 11, color: '#7c3aed', fontWeight: 500, letterSpacing: 0.3 }}>Self Check-in</span>
              </div>
              {/* QR */}
              <QRCode
                value={selectedQrCodeLocation ? `${window.location.origin}/remotecheckin/${(selectedQrCodeLocation.iata || '').toUpperCase()}-${selectedQrCodeLocation.id}` : ''}
                size={200}
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                fgColor="#000000"
                bgColor="#fff"
                title={'Passenger check-in'}
                logoImage={brandLogo}
                logoWidth={36}
                logoHeight={36}
                logoOpacity={1}
                logoPaddingStyle="square"
                qrStyle="square"
                eyeColor="#000000"
                quietZone={6}
                removeQrCodeBehindLogo={false}
                logoPadding={1}
              />
              <p style={{ fontSize: 12, color: "#9ca3af", margin: 0, textAlign: 'center' }}>Scanned by passenger phone camera</p>
              {/* Download single */}
              <button
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, width: '100%', height: 38, borderRadius: 7, border: '1.5px solid #6f42c1', background: '#f5f3ff', color: '#6f42c1', fontWeight: 600, fontSize: 13, cursor: 'pointer', transition: 'all 0.15s' }}
                title="Download PAX QR Code"
                onClick={() => handlePaxQrCodeDownload(selectedLocation)}
                onMouseEnter={e => { e.currentTarget.style.background = '#6f42c1'; e.currentTarget.style.color = '#fff'; }}
                onMouseLeave={e => { e.currentTarget.style.background = '#f5f3ff'; e.currentTarget.style.color = '#6f42c1'; }}
              >
                <BsDownload size={14} /> Download PAX
              </button>
              {/* Download All PAX PDF */}
              <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 6 }}>
                <button
                  title="Download All PAX QR Codes as PDF"
                  disabled={isDownloadingPaxPdf}
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, width: '100%', height: 38, borderRadius: 7, border: '1.5px solid #ddd6fe', background: isDownloadingPaxPdf ? '#ede9fe' : '#f5f3ff', color: '#6d28d9', fontWeight: 600, fontSize: 13, cursor: isDownloadingPaxPdf ? 'not-allowed' : 'pointer', whiteSpace: 'nowrap', transition: 'all 0.15s' }}
                  onMouseEnter={e => { e.currentTarget.style.background = '#6f42c1'; e.currentTarget.style.color = '#fff'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = '#f5f3ff'; e.currentTarget.style.color = '#6f42c1'; }}
                  onClick={async () => {
                    setIsDownloadingPaxPdf(true);
                    setPaxPdfDownloadProgress(0);
                    try {
                      await handlePaxQrCodeDownloadAllPdf(allAirportLocations, (progress) => {
                        setPaxPdfDownloadProgress(progress);
                      });
                    } catch (error) {
                      console.error("Error downloading PAX PDF:", error);
                      alert("Error generating PDF. Please try again.");
                    } finally {
                      setIsDownloadingPaxPdf(false);
                      setPaxPdfDownloadProgress(0);
                    }
                  }}
                >
                  <BsDownload size={14} />
                  {isDownloadingPaxPdf ? `${paxPdfDownloadProgress}%…` : "Download All (PDF)"}
                </button>
                {isDownloadingPaxPdf && (
                  <div style={{ width: '100%', height: 4, backgroundColor: '#e5e7eb', borderRadius: 4, overflow: 'hidden' }}>
                    <div style={{ width: `${paxPdfDownloadProgress}%`, height: '100%', backgroundColor: '#374151', transition: 'width 0.3s ease' }} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </NewScreen>
  );
};

export default Timeline;
